export default "<div class=\"option color\" style=\"background:{{data.Value}}\" id=\"{{value}}\" title=\"{{label}}\">\n</div>";